module.exports = __webpack_public_path__ + "static/img/bg.c5380290.png";